import Text from "@/components/common/Typography/Text"
import { cabinClasses } from "@/constants/flight/cabinClass"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { flightActions } from "@/lib/redux/features/flight/reduce"
import { faCouch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Select, SelectProps } from "antd"
import { FC } from "react"
import { useTranslation } from "react-i18next"

type SelectCabinClassProps = SelectProps

const SelectCabinClass: FC<SelectCabinClassProps> = (props) => {
  const cabinClass = useAppSelector(state => state.flight.cabinClass)
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  return (
    <Select
      prefix={<Text type='secondary'><FontAwesomeIcon icon={faCouch} /></Text>}
      value={cabinClass}
      className="home__searching--select-cabin"
      popupMatchSelectWidth={false}
      size='large'
      onChange={(v) => dispatch(flightActions.selectCabinClass(v))}
      options={[
        {
          value: "",
          label: t("common.all"),
          className: "home__searching--select-cabin--item"
        },
        {
          value: cabinClasses.Economy.code,
          label: t(cabinClasses.Economy.name),
          className: "home__searching--select-cabin--item"
        },
        {
          value: cabinClasses.Business.code,
          label: t(cabinClasses.Business.name),
          className: "home__searching--select-cabin--item"
        },
        // {
        //   value: cabinClasses["First Class"].code,
        //   label: t(cabinClasses["First Class"].name),
        //   className: "home__searching--select-cabin--item"
        // }
      ]}
      {...props}
    />
  )
}

SelectCabinClass.displayName = 'SelectCabinClass'

export default SelectCabinClass